<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="pwdHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import SecuserForm from "../../../components/settings/secuser/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": SecuserForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('recuser.newuser'),
      pageTitleValue: "",
      formData: {
        userid: null,
        psnid: null,
        psnname: null,
        usertypeid: null,
        startdate: null,
        enddate: null,
        lastaccess: null,
        lastaccdays: null,
        pwdlastchg: null,
        pwdchgdays: null,
        activate: true,
        status: null,
        passwd: null,
        idno: null,
        chgsrc: null,
        stamp: 0,
        id: this.$store.getters.userId,
      },
      idno: null,
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    pwdHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }
      this.$store.dispatch('get', {url: "/person/" + this.formData.psnid})
        .then((res) => {
          this.idno = res.data.rec[0].idno;

          if (vm.idno == null || vm.idno == undefined) {
            this.formData.passwd = this.formData.userid;
          } else {
            this.formData.passwd = this.idno.split("-").join("");
          }
          this.saveHandler();
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      //Convert boolean to integer. 1 = true, 0 = false
      if (this.formData.activate == true) {
        this.formData.activate = 1;
      } else {
        this.formData.activate = 0;
      }

      this.$store.dispatch('post', {url: "/secuser/create", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "secuserlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "secuserlist" });
    },
  },
};
</script>